import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import IconButton from '@cotyorg/ccx-molecules/IconButton';
import BBCodeParser from '@cotyorg/ccx-utils/js/components/BBCodeParser';
import {
  hideCookie as hideCookieAction,
  readCookie as readCookieAction,
} from './modules';

const Cookie = ({
  position,
  content,
  hideCookie,
  readCookie,
  isCookieHidden,
  closeIconSrc,
}) => {
  if (!content || isCookieHidden) {
    readCookie();
    return false;
  }

  const cookieCssClass = classNames('cookie', {
    [`cookie--${position}`]: position,
  });

  const {
    title,
    description,
    dismissText,
  } = content;

  return (
    <div className={cookieCssClass} role="alert">
      <div className="cookie__overlay">
        <div className="grid-container">
          <div className="cookie__wrapper">
            <div className="cookie__main">
              <h5 className="cookie__title">{title}</h5>
              <p className="cookie__info footnote">
                <BBCodeParser>
                  {description}
                </BBCodeParser>
              </p>
            </div>
            <IconButton
              extraClass="cookie__toggle"
              color="transparent"
              iconSrc={closeIconSrc}
              className="cookie__button"
              onClick={hideCookie}
            >
              <span className="show-for-sr">{dismissText}</span>
            </IconButton>
          </div>
        </div>
      </div>
    </div>
  );
};

Cookie.propTypes = {
  position: PropTypes.oneOf(['bottom', 'top']),
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string.isRequired,
    dismissText: PropTypes.string.isRequired,
  }),
  hideCookie: PropTypes.func.isRequired,
  readCookie: PropTypes.func.isRequired,
  isCookieHidden: PropTypes.bool.isRequired,
  closeIconSrc: PropTypes.string,
};

const mapStateToProps = state => ({
  isCookieHidden: state.cookie.isCookieHidden,
});

const mapDispatchToProps = dispatch => ({
  hideCookie: () => dispatch(hideCookieAction()),
  readCookie: () => dispatch(readCookieAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Cookie);
